/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class CollaboratorService extends __BaseService {
  static readonly getCollaboratorListPath = '/collaborator';
  static readonly inviteCollaboratorPath = '/collaborator';
  static readonly getCollaboratorDetailPath = '/collaborator/edit/{id}';
  static readonly updateRolePath = '/collaborator/{id}';
  static readonly deleteCollaboratorPath = '/collaborator/{id}';
  static readonly reactivateCollaboratorPath = '/collaborator/reactivate/{id}';
  static readonly resendInvitationPath = '/resendInvitation';
  static readonly registerCollaboratorPath = '/collaborator/register';
  static readonly loginCollaboratorPath = '/collaborator/login';
  static readonly verifyCollaboratorPath = '/collaborator/{token}';
  static readonly spaceInviteCollaboratorPath = '/spaceCollaborator';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get list of collaborator.
   * @param params The `CollaboratorService.GetCollaboratorListParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getCollaboratorListResponse(params: CollaboratorService.GetCollaboratorListParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/collaborator`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get list of collaborator.
   * @param params The `CollaboratorService.GetCollaboratorListParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `lang`: Language short code.
   */
  getCollaboratorList(params: CollaboratorService.GetCollaboratorListParams): __Observable<null> {
    return this.getCollaboratorListResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Invite collaborator.
   * @param params The `CollaboratorService.InviteCollaboratorParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Invite collaborator.
   */
  inviteCollaboratorResponse(params: CollaboratorService.InviteCollaboratorParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/collaborator`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Invite collaborator.
   * @param params The `CollaboratorService.InviteCollaboratorParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Invite collaborator.
   */
  inviteCollaborator(params: CollaboratorService.InviteCollaboratorParams): __Observable<null> {
    return this.inviteCollaboratorResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Set as initial view.
   * @param params The `CollaboratorService.GetCollaboratorDetailParams` containing the following parameters:
   *
   * - `id`: Collaborator Detail.
   *
   * - `Authorization`:
   */
  getCollaboratorDetailResponse(params: CollaboratorService.GetCollaboratorDetailParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/collaborator/edit/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Set as initial view.
   * @param params The `CollaboratorService.GetCollaboratorDetailParams` containing the following parameters:
   *
   * - `id`: Collaborator Detail.
   *
   * - `Authorization`:
   */
  getCollaboratorDetail(params: CollaboratorService.GetCollaboratorDetailParams): __Observable<null> {
    return this.getCollaboratorDetailResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Update hotspot.
   * @param params The `CollaboratorService.UpdateRoleParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update collaborator role.
   */
  updateRoleResponse(params: CollaboratorService.UpdateRoleParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/collaborator/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Update hotspot.
   * @param params The `CollaboratorService.UpdateRoleParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   *
   * - `body`: Update collaborator role.
   */
  updateRole(params: CollaboratorService.UpdateRoleParams): __Observable<null> {
    return this.updateRoleResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Delete Collaborator.
   * @param params The `CollaboratorService.DeleteCollaboratorParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteCollaboratorResponse(params: CollaboratorService.DeleteCollaboratorParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/collaborator/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Delete Collaborator.
   * @param params The `CollaboratorService.DeleteCollaboratorParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  deleteCollaborator(params: CollaboratorService.DeleteCollaboratorParams): __Observable<null> {
    return this.deleteCollaboratorResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Set as initial view.
   * @param params The `CollaboratorService.ReactivateCollaboratorParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  reactivateCollaboratorResponse(params: CollaboratorService.ReactivateCollaboratorParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/collaborator/reactivate/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Set as initial view.
   * @param params The `CollaboratorService.ReactivateCollaboratorParams` containing the following parameters:
   *
   * - `id`: Uuid value.
   *
   * - `Authorization`:
   */
  reactivateCollaborator(params: CollaboratorService.ReactivateCollaboratorParams): __Observable<null> {
    return this.reactivateCollaboratorResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Resend Invitation.
   * @param params The `CollaboratorService.ResendInvitationParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Resend Invitation.
   */
  resendInvitationResponse(params: CollaboratorService.ResendInvitationParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/resendInvitation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Resend Invitation.
   * @param params The `CollaboratorService.ResendInvitationParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Resend Invitation.
   */
  resendInvitation(params: CollaboratorService.ResendInvitationParams): __Observable<null> {
    return this.resendInvitationResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Register Collaborator.
   * @param body Register collaborator
   */
  registerCollaboratorResponse(body?: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/collaborator/register`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Register Collaborator.
   * @param body Register collaborator
   */
  registerCollaborator(body?: {}): __Observable<null> {
    return this.registerCollaboratorResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Login collaborator.
   * @param body Login collaborator
   */
  loginCollaboratorResponse(body?: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/collaborator/login`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Login collaborator.
   * @param body Login collaborator
   */
  loginCollaborator(body?: {}): __Observable<null> {
    return this.loginCollaboratorResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Verify collaborator.
   * @param token undefined
   */
  verifyCollaboratorResponse(token: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/collaborator/${encodeURIComponent(String(token))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Verify collaborator.
   * @param token undefined
   */
  verifyCollaborator(token: string): __Observable<null> {
    return this.verifyCollaboratorResponse(token).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Space Invite Collaborator.
   * @param params The `CollaboratorService.SpaceInviteCollaboratorParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Space Invite collaborator.
   */
  spaceInviteCollaboratorResponse(params: CollaboratorService.SpaceInviteCollaboratorParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/spaceCollaborator`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Space Invite Collaborator.
   * @param params The `CollaboratorService.SpaceInviteCollaboratorParams` containing the following parameters:
   *
   * - `Authorization`:
   *
   * - `body`: Space Invite collaborator.
   */
  spaceInviteCollaborator(params: CollaboratorService.SpaceInviteCollaboratorParams): __Observable<null> {
    return this.spaceInviteCollaboratorResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module CollaboratorService {

  /**
   * Parameters for getCollaboratorList
   */
  export interface GetCollaboratorListParams {
    Authorization: string;

    /**
     * Language short code.
     */
    lang?: string;
  }

  /**
   * Parameters for inviteCollaborator
   */
  export interface InviteCollaboratorParams {
    Authorization: string;

    /**
     * Invite collaborator.
     */
    body?: {};
  }

  /**
   * Parameters for getCollaboratorDetail
   */
  export interface GetCollaboratorDetailParams {

    /**
     * Collaborator Detail.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for updateRole
   */
  export interface UpdateRoleParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;

    /**
     * Update collaborator role.
     */
    body?: {};
  }

  /**
   * Parameters for deleteCollaborator
   */
  export interface DeleteCollaboratorParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for reactivateCollaborator
   */
  export interface ReactivateCollaboratorParams {

    /**
     * Uuid value.
     */
    id: string;
    Authorization: string;
  }

  /**
   * Parameters for resendInvitation
   */
  export interface ResendInvitationParams {
    Authorization: string;

    /**
     * Resend Invitation.
     */
    body?: {};
  }

  /**
   * Parameters for spaceInviteCollaborator
   */
  export interface SpaceInviteCollaboratorParams {
    Authorization: string;

    /**
     * Space Invite collaborator.
     */
    body?: {};
  }
}

// @ts-ignore
export { CollaboratorService }
